import PropTypes from "prop-types";
import "@asosteam/chameleon-tokens-asos/css-variables.css";
import "./tokens.css";
import PremierCancellationLayout from "./containers/premier-cancellation-layout";
import { CancellationFormDetailsProvider } from "./context/cancellation-details";
import { cancellationFormDetailsReducer } from "./state/cancellation-form-details/reducer";
import styles from "./styles";
import { LocaleProvider } from "./context/locale-provider";

export default function App({ storeData }) {
  const { faqlink } = storeData.languageStrings;
  return (
    <div className={styles.container}>
      <LocaleProvider languageStrings={storeData.languageStrings}>
        <CancellationFormDetailsProvider
          initialState={{
            loading: true,
            hasError: false,
            cancellationFormDetails: {
              firstName: "",
              lastName: "",
              email: "",
              reason: "",
            },
          }}
          reducer={cancellationFormDetailsReducer}
        >
          <PremierCancellationLayout faqlink={faqlink} />
        </CancellationFormDetailsProvider>
      </LocaleProvider>
    </div>
  );
}

App.propTypes = {
  storeData: PropTypes.object,
};

App.defaultProps = {
  storeData: {
    languageStrings: {},
  },
};
